import { formAction } from "v2/dataroutes/BillingData";


export const ActiveSubscriptionFormActions = {
  cancel: formAction("cancel"),
  downgrade: formAction("downgrade"),
  remove_scheduled_changes: formAction("remove_scheduled_changes"),
  renew: formAction("renew"),
  upgrade: formAction("upgrade")
};
